import styled from 'styled-components';
import {
    FAIL_COLOR
  } from '../../const/color';
  import { device } from '../../const/device';

 const Notification = styled.div`
    padding:10px;
    font-size:20px;
    top:0;
    position:fixed;
    border-radius:5px;
    z-index:1000;
    transform: translate(-50%,10px);
    left: 50%;
    white-space:nowrap;

    @media(${device.tablet}){
        font-size:16px;
    }

    @media(${device.mobileM}){
        font-size:14px;
    }
`;

export const ErrorNotification = styled(Notification)`
    background:${FAIL_COLOR};
    color:white;
`;